import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=407ad528&scoped=true&"
import script from "./questionBank.vue?vue&type=script&lang=js&"
export * from "./questionBank.vue?vue&type=script&lang=js&"
import style0 from "./questionBank.vue?vue&type=style&index=0&id=407ad528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ad528",
  null
  
)

export default component.exports